import React from "react";
// UI Framework
import { ReloadOutlined } from "@ant-design/icons";
// Common Components
import { CheckBox, FileDownloader, DynamicDropdown } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Requests
import { getTableExcel, getSellTable } from "src/Requests/synthetic";
import { getStepInstruments } from "src/Requests/stepRequests";
// Types
import {
  ISyntheticSearchParams,
  ISyntheticPurchaseTableReport,
} from "src/Interfaces/Synthetic";

const BuyOrSell: React.FC = () => {
  // local store
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [searchParam, setSearchParam] = React.useState<ISyntheticSearchParams>(
    {} as ISyntheticSearchParams
  );

  React.useEffect(() => {
    if (refreshFlag) setTimeout(() => setRefreshFlag(false), 1500);
  }, [refreshFlag]);

  const handleExcelDownload = () =>
    getTableExcel("sell", { insId: searchParam?.insId });

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative pt-5 mx-auto p-8 w-full h-full overflow-y-hidden">
      <div className="flex justify-between items-center w-full">
        <div className="flex flex-row justify-start items-center gap-5">
          {searchParam?.insId ? (
            <FileDownloader getFile={handleExcelDownload} />
          ) : (
            <></>
          )}
        </div>

        <div className="w-56 flex flex-row justify-start items-center gap-2">
          <div
            onClick={() => setRefreshFlag(true)}
            className="cursor-pointer mt-5"
          >
            <ReloadOutlined className={refreshFlag ? "animate-spin" : ""} />
          </div>
          <DynamicDropdown
            dropdown={{
              name: "insId",
              placeholder: "نماد",
              extraLabel: true,
            }}
            getData={getStepInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam.insId}
          />
        </div>
      </div>

      <TableTemplate<ISyntheticSearchParams, ISyntheticPurchaseTableReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={refreshFlag}
            tableBoxClassName="max-h-[700px] overflow-auto"
          />
        )}
        getDataTable={getSellTable}
        withSort
        searchParameters={searchParam}
      />
    </div>
  );
};
export default BuyOrSell;
